/** Quick filter ids for notifications list (server-side type + read filters). */
export const NOTIFICATION_QUICK_FILTER_IDS = [
  'all',
  'unread',
  'events',
  'friends',
  'applications',
  'alerts',
  'badges',
];

const EVENT_TYPES = [
  'event_created',
  'event_starts_soon',
  'event_started',
  'event_cancelled',
  'event_invitation',
  'friend_joined_event',
  /** Organizator: ktoś zapisał się na wydarzenie i czeka na akceptację */
  'application_received',
];

const FRIEND_TYPES = ['friend_invitation', 'friendship_accepted'];

/** Zgłoszenia uczestnika: własna akceptacja / odrzucenie zapisu na wydarzenie */
const APPLICATION_TYPES = ['application_accepted', 'application_rejected'];

const ALERT_TYPES = ['application_rejected', 'event_cancelled', 'participant_kicked'];

const BADGE_TYPES = ['badge_unlocked'];

/**
 * @param {string} filterId
 * @returns {{ read: boolean | null, types: string[] | null }}
 */
export function getNotificationQuickFilterQuery(filterId) {
  switch (filterId) {
    case 'unread':
      return { read: false, types: null };
    case 'events':
      return { read: null, types: EVENT_TYPES };
    case 'friends':
      return { read: null, types: FRIEND_TYPES };
    case 'applications':
      return { read: null, types: APPLICATION_TYPES };
    case 'alerts':
      return { read: null, types: ALERT_TYPES };
    case 'badges':
      return { read: null, types: BADGE_TYPES };
    case 'all':
    default:
      return { read: null, types: null };
  }
}
